import React from 'react'
import styled from "styled-components"

import { Link as InternalLink } from "gatsby"

import { typeHeading02, typeHeading04, typeBody02, typeLabel01 } from '../../theme/typography'
import { grid, row, column } from '../../theme/grid'
import { spacer, unit, pixelate, margin, SIZE, mediaQuery } from '../../theme/metrics'
import { WHITE_01, GREY_01 } from '../../theme/colors'

import { StyledButtons } from '../../theme/components';

export const Inner = styled.div`
	${props => row({medium:true})}
`

export const Content = styled.div`
	${props => column({medium:{span:8,before:2,after:2}},{direction:props.theme.direction})}
	text-align: center;
`


export const Heading = styled.div`
	${typeHeading02}
	text-align: center;
	color: ${props => props.theme.foreground};
	padding-bottom: ${spacer(1)};
`

export const Buttons = styled(StyledButtons)`
	flex: 1;
	display: flex;
	align-items: center;
	justify-content: center;
`